var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addressBox" },
    [
      _c("div", { staticClass: "addAddressBox" }, [
        _c(
          "span",
          { staticClass: "addAddressBtn", on: { click: _vm.addAddressBtn } },
          [_vm._v("新增收货地址")]
        )
      ]),
      _vm._v(" "),
      _vm.flag
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "addressList clearfix sub-main"
            },
            [
              _vm._l(_vm.addressData.list, function(item) {
                return _c(
                  "div",
                  {
                    key: item.receiveId,
                    staticClass: "addressItem",
                    class: { active: item.defult }
                  },
                  [
                    _c("div", { staticClass: "listItemInfoBox" }, [
                      _c(
                        "div",
                        { staticClass: "isDefault" },
                        [
                          _c("span", [_vm._v("设为默认地址")]),
                          _vm._v(" "),
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#FF7800",
                              "inactive-color": "#c1c1c1"
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeDefultAd(item)
                              }
                            },
                            model: {
                              value: item.defult,
                              callback: function($$v) {
                                _vm.$set(item, "defult", $$v)
                              },
                              expression: "item.defult"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "addressInfo" }, [
                        _c("div", { staticClass: "infoItem" }, [
                          _vm._v("收货人：" + _vm._s(item.receiveName))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "infoItem" }, [
                          _vm._v("所在地区：" + _vm._s(item.receiveAdress))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "infoItem" }, [
                          _vm._v("详细地址：" + _vm._s(item.address))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "infoItem" }, [
                          _vm._v("手机号：" + _vm._s(item.receivePhone))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "addressChange" }, [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.showDelete(item)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                          _vm._v("删除")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changeAddress(item)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                          _vm._v("修改")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.isDefault,
                              expression: "item.isDefault"
                            }
                          ],
                          staticClass: "iconfont defaultActive"
                        },
                        [_vm._v("")]
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next, jumper",
                  "page-size": 4,
                  "current-page": _vm.page,
                  total: _vm.addressData.total
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            2
          )
        : _c("div", { staticClass: "nothing sub-main" }, [
            _c("img", {
              attrs: {
                src: require("../../../../static/image/nothing@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "fs20 font-color-999" }, [
              _vm._v("您还没有收货地址～")
            ])
          ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新建收货地址",
            visible: _vm.addAddressShow,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.addAddressShow = $event
            }
          }
        },
        [
          _c("add-address", {
            on: { hideAddDialog: _vm.hideAddDialog, cancelAdd: _vm.closeAdd }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "是否删除此项",
            visible: _vm.showDeleteAdd,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showDeleteAdd = $event
            }
          }
        },
        [
          _c("div", { staticClass: "deleteAddInfo" }, [
            _c("p", [
              _vm._v("收货人： " + _vm._s(_vm.delCurrentAdd.receiveName))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("手机号码： " + _vm._s(_vm.delCurrentAdd.receivePhone))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "收货地址： " +
                  _vm._s(_vm.delCurrentAdd.receiveAdress) +
                  " " +
                  _vm._s(_vm.delCurrentAdd.address)
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  directives: [{ name: "throttle", rawName: "v-throttle" }],
                  attrs: { type: "primary" },
                  on: { click: _vm.deleteAdd }
                },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showDeleteAdd = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-66b9d65a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-66b9d65a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/signingAddress/signingAddress.vue
// module id = null
// module chunks = 